module.exports = __webpack_public_path__ + "img/icon_new_2.f85ca6b2.png";